<!--商家收益明细-->
<!--团队业绩-->
<template>
    <div style="height:100%">
        <div class="handleBox flex flex-ai-c">
            <el-page-header @back="goBack" content="店铺收益明细" style="color:#95A1B9"></el-page-header>
        </div>

        <div class="totalBox">
            <el-row type="flex" justify="space-between" :gutter="10">
                <el-col>
                    <el-card shadow="hover">
                        <p class="totalNum">{{data.order_count}}</p>
                        <p class="totalText">总订单</p>
                    </el-card>
                </el-col>
                <el-col>
                    <el-card shadow="hover">
                        <p class="totalNum">{{data.order_amount}}</p>
                        <p class="totalText">订单总金额</p>
                    </el-card>
                </el-col>
                <el-col>
                    <el-card shadow="hover">
                        <p class="totalNum">{{data.all_shang_income}}</p>
                        <p class="totalText">总收入</p>
                    </el-card>
                </el-col>
                <el-col>
                    <el-card shadow="hover">
                        <p class="totalNum">{{data.all_shang_ji_fen}}</p>
                        <p class="totalText">总积分</p>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!-- 表格 -->
        <div class="tabSwitch">
            <el-tabs v-model="type" :stretch="true" @tab-click="handleClick">
                <el-tab-pane label="店铺收益" name="1"></el-tab-pane>
                <el-tab-pane label="积分收益" name="2"></el-tab-pane>
                <el-tab-pane label="总收入" name="3"></el-tab-pane>
            </el-tabs>
        </div>

        <div class="table" style="height:calc( 100% - 260px );margin-top:8px">
            <el-table v-if="type == 1" ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
                <el-table-column prop="order_num" label="订单编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="goods_pic" label="商品图片" width="90" align="center">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.goods_pic" class="main_pic" :src="getImgUrl(scope.row.goods_pic)" fit="cover" :preview-src-list="[domain + '/' + scope.row.goods_pic]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_name" label="商品标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="number" label="销售数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="price" label="销售价格" show-overflow-tooltip></el-table-column>
                <el-table-column prop="user_name" label="购买人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="yong_name" label="佣金比例" show-overflow-tooltip></el-table-column>
                <el-table-column prop="shang_goods_fee" label="到账金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="购买日期" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-table v-if="type==2" ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
                <el-table-column type="index" label="序号">
                    <template slot-scope="scope">
                        {{ (curr - 1) * row + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="type_name" label="收益类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="order_no" label="订单编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="积分" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.direction}} {{scope.row.num}}
                    </template>
                </el-table-column>
                <el-table-column prop="to" label="总积分" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="生成时间" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-table v-if="type==3" ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )">
                <el-table-column type="index" label="序号">
                    <template slot-scope="scope">
                        {{ (curr - 1) * row + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="type_name" label="收益类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="order_no" label="订单编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="收入" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.direction}} {{scope.row.num}}
                    </template>
                </el-table-column>
                <el-table-column prop="to" label="目前收入" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="生成时间" show-overflow-tooltip></el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="paging">
                <el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {},
            list: [],

            curr: 1, //页码
            row: 10, //每页条数
            pages: 1, //总页数
            count: 0, //总条数
            total: 0,

            type: '1'
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            let url = this.type == 1 ? '/admin/Order/indexShangProfit' : this.type == 2 ? '/admin/UserJiFen/indexShangJiFen' : '/admin/UserJiFen/indexShangIncome';
            this.http.post(url, {
                curr: this.curr,
                row: this.row,
                shang_jia_id: this.$route.query.id
            }).then(res => {
                this.data = res;
                this.list = res.list;
                this.curr = res.curr;
                this.pages = res.pages;
                this.count = res.count;
                this.total = res.total;
            });
        },

        //切换tab
        handleClick: function () {
            this.list = [];
            this.curr = 1;
            this.getList();
        },

        // 查看图片
        getImageUrl: function (url) {
            this.dialogImageUrl = this.domain + url;
            // this.dialogVisible = true;
        },
        // 图片转换
        getImgUrl(item) {
            var url = this.domain + item;
            return url;
        },

        //翻页
        currentChange: function (curr) {
            this.curr = curr;
            this.getList();
        },

        //改变每页条数
        sizeChange: function (row) {
            this.row = row;
            this.getList();
        },

        //返回
        goBack: function () {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="less">
.userLabel {
    width: 200px;
}
.userContent {
    width: calc((100vw - 400px) / 2) !important;
}
.tabSwitch {
    background: #fff;
    margin-bottom: 0;
    .el-tabs__header {
        margin-bottom: 0 !important;
    }
}
</style>

